<template>
	<b-overlay :show="showOverlay" rounded="sm">
		<b-card class="sa-card sa-card-dashbord sa-header-nowrap sa-info-card-dashboard" header-tag="header" footer-tag="footer" title="">
			<template v-if="!view" #header>
				<div style="display: flex">
					<span style="flex: 1">{{ chartParams.title }}</span>
					<b-button size="sm" variant="outline-secondary outline-secondary-noborder pull-right" @click="onClickEditConfigChart()">
						<i class="fas fa-pencil-alt"></i>
					</b-button>
					<b-button size="sm" variant="outline-danger outline-secondary-noborder pull-right" @click="onClickRimuoviOggetto()">
						<i class="fas fa-trash"></i>
					</b-button>
				</div>
			</template>
			<b-card-body>
				<div class="sa-widget-body-data">
					<div v-if="mxChartConfig.colorIconClass" class="sa-widget-body-data-left">
						<div :class="mxChartConfig.colorIconClass" class="sa-widget-header-icon-box">
							<i :class="mxChartConfig.icon" class="mr-0"></i>
						</div>
					</div>

					<div class="sa-widget-body-data-content">
						<span class="sa-widget-body-data-title">{{ mxChartConfig.title }}</span>
						<h3>{{ mxChartConfig.aggregationResult }} {{ mxChartConfig.tipologyData }} {{ valoreProporzionale }}</h3>
						<span class="sa-widget-body-data-subtitle">
							<small :class="secondaryColor">
								<span v-if="secondaryIconVisible" :key="iconKey">
									<i :class="secondaryIcon"></i>
								</span>
								{{ secondaryValue }} {{ mxChartConfig.secondaryLabel }}</small
							>
						</span>
					</div>
				</div>
			</b-card-body>
		</b-card>
		<widget-editor-header ref="cmpWidgetEditorHeader" :config="chartParams" @updateConfig="onUpdateConfig"></widget-editor-header>
	</b-overlay>
</template>

<script>
import axios from "axios";
//import DataAnalysisEditConfigChartModalComponent from "./DataAnalysisEditConfigChartModalComponent.vue";
import WidgetEditorHeader from "./WidgetEditorHeader.vue";
import DataAnalysisHeaderMixin from "../mixins/DataAnalysisHeaderMixin";
export default {
	props: {
		chartParams: { type: Object },
		view: {
			type: Boolean,
			default: () => {
				return false;
			},
		},
	},
	mixins: [DataAnalysisHeaderMixin],
	components: { WidgetEditorHeader },
	data() {
		return {
			showOverlay: true,
			pathResourceData: "/dataanalysisdatabaseinfo/eseguigraphicquery",
			value: null,
			iconKey: 0,
		};
	},
	created() {
		this.setMxChartConfig(this.chartParams);
	},
	computed: {
		borderStyle() {
			// Definiamo i colori principali per ogni palette
			const paletteColors = {
				standard: "#5470c6",
				vintage: "#d87c7c",
				cool: "#007bff",
				warm: "#ff8b00",
				neon: "#00f5d4",
			};

			const color = paletteColors[this.chartParams.colorPalette] || "var(--bg-sidebar)";

			return {
				"border-left": `5px solid ${color}!important`,
			};
		},
	},
	mounted() {
		this.$emit("beforeLoadData", this.chartParams);
		this.loadWidgetData();
	},
	methods: {
		setValueData() {
			this.loadDataQuery();
		},
		loadDataQuery() {
			let me = this;
			let link = process.env.VUE_APP_PATH_API + me.pathResourceData + "/" + me.chartParams.idQuery;
			axios.get(link)
				.then((response) => {
					this.testData = response.data.data;
					me.showOverlay = false;
				})
				.catch((e) => {
					console.log(e);
				});
		},
		onClickEditConfigChart() {
			console.log("OK");
			let me = this;
			me.$refs.cmpWidgetEditorHeader.setChartParams(me.chartParams);
			me.$refs.cmpWidgetEditorHeader.show();
		},
		onUpdateConfig(chartParams) {
			this.showOverlay = true;
			this.loadDataQuery();
			console.log("ok update config Header Edit", chartParams);

			this.$emit("updateChart", chartParams);
		},
		onClickRimuoviOggetto() {
			this.$emit("removeObject", this.chartParams);
		},
	},
};
</script>

<style></style>
